<div class="container">
    <portals-name-avatar
        [fullName]="note.createdBy.fullName"
    ></portals-name-avatar>
    <div class="main">
        <div
            style="
                display: flex;
                align-items: center;
                justify-content: space-between;
            "
        >
            <div class="content">{{ note.content }}</div>

            <div
                [routerLink]="['/session-report', note._id]"
                [queryParams]="getOrgAwareMenuQueryParams()"
                style="font-size: 24px; cursor: pointer"
            >
                <i class="fa-regular fa-file-lines"></i>
            </div>
        </div>
        <div class="footer">
            <p class="name">{{ note.createdBy.fullName }}</p>
            <p *ngIf="note.consultType" class="consult-type">
                {{ types[note.consultType] || note.consultType }}
            </p>
            <p class="date">{{ note.createdAt | date : 'short' }}</p>
        </div>
    </div>
</div>
